export default class Collection {
    constructor() {
        this.createCollectionActions    = document.querySelectorAll('.create-collection-form');
        this.deleteCollection           = document.querySelectorAll('.delete-collection');
        this.addToCollectionPopup       = document.querySelectorAll('.add-to-collection');
        this.addToCollectionActions     = document.querySelectorAll('.add-to-collection-form');
		this.shareCollectionPopup       = document.querySelectorAll('.share-collection');
        this.unshareCollectionAction    = document.querySelectorAll('.unshare-collection');
        this.shareCollectionLink    	= document.querySelectorAll('.share-collection-link');
		this.shareCollectionAction      = document.getElementById('share-collection');

        // Working
        if(this.createCollectionActions) {
            this.createCollectionActions.forEach((createCollectionAction) => {
                createCollectionAction.addEventListener("submit", (event) => {
                    event.preventDefault();
                    this.veritoneCreateCollection(createCollectionAction);
                    event.stopImmediatePropagation();
                });
            });
        }

        // Working
        if(this.deleteCollection) {
            this.deleteCollection.forEach((button) => {
                button.addEventListener("click", (event) => {
                    event.preventDefault();
                    this.veritoneDeleteCollection(button.dataset.id);
                });
            });
        }

        // Working
        if(this.addToCollectionActions) {
            this.addToCollectionActions.forEach((addToCollectionAction) => {
                addToCollectionAction.addEventListener("click", (event) => {
                    event.preventDefault();
                    this.veritoneAddToCollection('', addToCollectionAction);
                });
            });
        }

        if(this.unshareCollectionAction) {
            this.unshareCollectionAction.forEach((button) => {
                button.addEventListener("click", (event) => {
                    event.preventDefault();
                    this.veritoneUnShareCollection(button.dataset.shareid);
                });
            });
        }
    }

    // Veritone Create Collection
    veritoneCreateCollection(collectionForm = null) {
        document.body.classList.remove("loaded");
        let formData 				= new FormData(collectionForm);
        let collectionErrors				= document.getElementById("create-collection-errors");

        fetch('/wp/wp-admin/admin-ajax.php?action=veritoneCreateCollection', {
            method: 'POST',
            body: formData,
        })
        .then(response => response.json())
        .then(data => {
            if(data['fieldErrors']) {
                data['fieldErrors'].forEach((error) => {
                    collectionErrors.innerHTML += error['message'];
                });
                collectionErrors.classList.add('form-group__errors--open');
                document.body.classList.add("loaded");
            } else {
				let formData= new FormData();
				let modalName = 'collection-created';
				formData.append('modalName', modalName);

				fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
					method: 'POST',
					body: formData,
				})
				.then(response => response.json())
				.then(data => {
					document.querySelector('#modal__shell .modal__content').innerHTML = '';
					document.querySelector('#modal__shell .modal__content').insertAdjacentHTML('beforeend', data['modal']);
					document.querySelector('#modal__shell').classList.add('modal--large');
					document.body.classList.add('modal--open');
					document.body.classList.add("loaded");
				})

                collectionErrors.innerHTML = '';
                collectionErrors.classList.remove('form-group__errors--open');
                document.body.classList.add("loaded");
                if(data['page']) {
                    // Reload page
					location.reload();
                }
            }
        })
    }

    // Veritone Delete Collection
    veritoneDeleteCollection(collectionID) {
        document.body.classList.remove("loaded");
        let formData 				= new FormData();
        let collectionErrors				= document.getElementById("create-collection-errors");
        formData.append("collectionID", collectionID);

        fetch('/wp/wp-admin/admin-ajax.php?action=veritoneDeleteCollection', {
            method: 'POST',
            body: formData,
        })
		.then(response => response.json())
		.then(data => {
			if(data['fieldErrors']) {
				data['fieldErrors'].forEach((error) => {
					collectionErrors.innerHTML += error['message'];
				});
				collectionErrors.classList.add('form-group__errors--open');
			} else {
                // Reload page
                formData.append('pageName', 'account-collections');
                fetch('/wp/wp-admin/admin-ajax.php?action=injectPage', {
                    method: 'POST',
                    body: formData,
                })
                .then(response => response.json())
                .then(data => {
                    if(data['page']) {
                        // Clear page shell
                        document.querySelector('#page-shell').innerHTML = '';

                        // Append new data to page shell
                        document.querySelector('#page-shell').insertAdjacentHTML('beforeend', data['page']);

                        // Update URL to match new page
                        window.history.pushState('', '', data['url']);

                        // Stop page loader
                        document.body.classList.add("loaded");
                    }
                })
			}
		})
    }

    // Veritone Add to Collection
    veritoneAddToCollection(assetID, addForm = null) {
        document.body.classList.remove("loaded");
        let formData 	            = new FormData(addForm);
        let collectionErrors				= document.getElementById("create-collection-errors");

        fetch('/wp/wp-admin/admin-ajax.php?action=veritoneAddToCollection', {
            method: 'POST',
            body: formData,
        })
        .then(response => response.json())
        .then(data => {
            if(data['fieldErrors']) {
                data['fieldErrors'].forEach((error) => {
                    collectionErrors.innerHTML += error['message'];
                });
                collectionErrors.classList.add('form-group__errors--open');
            } else {
                console.log('Added to Collection');

                let formData= new FormData();
                let modalName = 'added-to-collection';
                formData.append('modalName', modalName);

                fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
                    method: 'POST',
                    body: formData,
                })
                .then(response => response.json())
                .then(data => {
                    document.querySelector('#modal__shell .modal__content').innerHTML = '';
                    document.querySelector('#modal__shell .modal__content').insertAdjacentHTML('beforeend', data['modal']);
                    document.querySelector('#modal__shell').classList.add('modal--large');
                    document.body.classList.add('modal--open');
                    document.body.classList.add("loaded");
                })
            }
            document.body.classList.add("loaded");
        })
    }

    // Veritone Unshare Collection
    veritoneUnShareCollection(shareId) {
        document.body.classList.remove("loaded");
        let formData 				= new FormData();
        formData.append("shareId", shareId);

        fetch('/wp/wp-admin/admin-ajax.php?action=veritoneUnShareCollection', {
            method: 'POST',
            body: formData,
        })
        .then(response => response.json())
        .then(data => {
            if(data['fieldErrors']) {
                data['fieldErrors'].forEach((error) => {
                    alert('Error');
                });
            } else {
                let formData= new FormData();
                let modalName = 'share-unshared';
                formData.append('modalName', modalName);

                fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
                    method: 'POST',
                    body: formData,
                })
                .then(response => response.json())
                .then(data => {
                    document.querySelector('#modal__shell .modal__content').innerHTML = '';
                    document.querySelector('#modal__shell .modal__content').insertAdjacentHTML('beforeend', data['modal']);
                    document.querySelector('#modal__shell').classList.add('modal--large');
                    document.body.classList.add('modal--open');
                    document.body.classList.add("loaded");
                })
            }
            document.body.classList.add("loaded");
			location.reload();
        })
    }

	// Veritone Share Collection
	veritoneShareCollection() {
        document.querySelector('#modal__shell').classList.add('modal--large');
        document.body.classList.remove("loaded");
		let formData = new FormData(document.getElementById("share-collection"));

		fetch('/wp/wp-admin/admin-ajax.php?action=veritoneShareCollection', {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(data => {
			let formData= new FormData();
			let modalName = 'share-created';
			formData.append('modalName', modalName);

			// REPLACE THIS
			fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
				method: 'POST',
				body: formData,
			})
			.then(response => response.json())
			.then(data => {
				document.querySelector('#modal__shell .modal__content').innerHTML = '';
				document.querySelector('#modal__shell .modal__content').insertAdjacentHTML('beforeend', data['modal']);
				document.querySelector('#modal__shell').classList.add('modal--large');
				document.body.classList.add('modal--open');
				document.body.classList.add("loaded");
			})
            document.body.classList.add("loaded");
			location.reload();
		})
	}

	// Veritone Share Collection Link
	veritoneShareCollectionLink(collectionID) {
        console.log('function veritoneShareCollectionLink');
		document.querySelector('#modal__shell').classList.add('modal--large');
		document.body.classList.remove("loaded");
		let formData = new FormData();
		formData.append('collectionID', collectionID);

		fetch('/wp/wp-admin/admin-ajax.php?action=veritoneShareCollectionLink', {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(data => {
            console.log('.then veritoneShareCollectionLink');
			let shareURL = data;

			if(document.getElementById("public-share-key")) {
				document.getElementById("public-share-key").innerHTML = shareURL;
			}

			let formData= new FormData();
			formData.append('modalName', 'share-collection-link');
			formData.append('shareURL', shareURL);

            console.log(shareURL);

			// REPLACE THIS
			fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
				method: 'POST',
				body: formData,
			})
			.then(response => response.json())
			.then(data => {
				document.querySelector('#modal__shell .modal__content').innerHTML = '';
				document.querySelector('#modal__shell .modal__content').insertAdjacentHTML('beforeend', data['modal']);
				document.querySelector('#modal__shell').classList.add('modal--large');
				document.body.classList.add('modal--open');
				document.body.classList.add("loaded");
			})
			document.body.classList.add("loaded");
		})
	}
} 